module.exports = __webpack_public_path__ + "larkin.png?c23bcc7fdc87660244d2dcdbb34ac866";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/dental/larkin.png
// module id = 57
// module chunks = 0